import { $api } from "@/shared/api";

// Сводка последних готовых разборов игрока (экран «Стиль игры»). Её `queryKey` инвалидирует
// `analysis.done`: готовый разбор меняет привычки, убийц и метрики.
export const analysesSummaryQueryOptions = () => $api.queryOptions("get", "/api/analyses/summary");
